import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router/router";
import store from "@/stores/store";
import { createHead } from "@vueuse/head";

createApp(App)
  .use(createHead())
  .use(router)
  .use(store)
  .mount('#app')
